import {useEffect,useRef,useState} from 'react';
import {claimMissionControlCustody,ClaimableIntakeItem,loadClaimableIntake} from './api';

type Props={refreshKey:number;onClaimed:()=>void};

function location(item:ClaimableIntakeItem){return [item.city,item.admin_area,item.country_code].filter(Boolean).join(', ')||'Location not yet recorded';}

export function MissionControlClaimableIntake({refreshKey,onClaimed}:Props){
  const[items,setItems]=useState<ClaimableIntakeItem[]|null>(null);
  const[failed,setFailed]=useState(false);
  const[readRefresh,setReadRefresh]=useState(0);
  const[pendingOrder,setPendingOrder]=useState('');
  const[claimStatus,setClaimStatus]=useState('');
  const claimStatusRef=useRef<HTMLParagraphElement>(null);

  useEffect(()=>{
    let active=true;setFailed(false);setItems(null);
    const timer=setTimeout(()=>{if(active){active=false;setFailed(true)}},15000);
    loadClaimableIntake().then(next=>{if(active){active=false;clearTimeout(timer);setItems(next)}})
      .catch(()=>{if(active){active=false;clearTimeout(timer);setFailed(true)}});
    return()=>{active=false;clearTimeout(timer)};
  },[refreshKey,readRefresh]);

  async function claim(item:ClaimableIntakeItem){
    if(pendingOrder)return;
    setPendingOrder(item.order_id);setClaimStatus('');
    try{
      await claimMissionControlCustody(item.customer_organization_id,item.order_id,item.order_version,crypto.randomUUID());
      setClaimStatus(`You now own ${item.customer_display_name} order ${item.order_id}. An immutable Mission Control custody event was recorded; the order now appears in your review and routing queues.`);
      onClaimed();
    }catch{
      setClaimStatus('Ownership could not be completed. Another operator may already own this order, or it changed. Reload and try again.');
    }finally{
      setPendingOrder('');
      requestAnimationFrame(()=>claimStatusRef.current?.focus());
    }
  }

  return <section className="panel" aria-labelledby="claimable-title">
    <p className="eyebrow">NEW INTAKE</p><h2 id="claimable-title">New intake awaiting ownership</h2>
    <p>Validated customer orders that no Mission Control operator owns yet. Recipient details and documents open only after you take ownership.</p>
    <p ref={claimStatusRef} tabIndex={-1} aria-live="polite" className="notice">{claimStatus}</p>
    <div aria-live="polite" aria-atomic="true">{failed&&<p className="notice error">New intake could not be loaded. Access was denied, multi-factor sign-in is required, or the service is unavailable.</p>}{!failed&&items===null&&<p className="notice">Checking for new intake…</p>}{!failed&&items?.length===0&&<p className="notice">No new intake is waiting for ownership.</p>}</div>
    {failed&&<button type="button" disabled={pendingOrder!==''} onClick={()=>setReadRefresh(value=>value+1)}>Reload new intake</button>}
    {items&&items.length>0&&<ol className="intake-list">{items.map((item)=><li className="intake-card" key={item.order_id}>
      <h3>{item.customer_display_name}</h3>
      <dl><div><dt>Service</dt><dd>{item.service_type_code??'Not yet recorded'}</dd></div><div><dt>Deadline</dt><dd>{item.deadline_date??'Not yet recorded'}</dd></div><div><dt>Location</dt><dd>{location(item)}</dd></div></dl>
      <p className="reference">Order {item.order_id} · version {item.order_version}</p>
      <button type="button" onClick={()=>claim(item)} disabled={pendingOrder!==''} aria-label={`Take ownership of ${item.customer_display_name} order ${item.order_id}`}>{pendingOrder===item.order_id?'Saving ownership…':'Take ownership'}</button>
    </li>)}</ol>}
  </section>;
}
